/** Settings: misma tarjeta que habitación + checkbox de selección (paridad Shelly/LG). */

import React from 'react';
import { Box, Checkbox } from '@mui/material';
import { EvohomeDevice } from '../../services/evohomeApi';
import EvohomeDeviceCard from './EvohomeDeviceCard';

interface EvohomeDeviceCardSettingsProps {
  device: EvohomeDevice;
  isSelected: boolean;
  editMode: boolean;
  isRoomEditing?: boolean;
  isEditingName?: boolean;
  dragHandleProps?: Record<string, unknown>;
  onSelect?: (id: number) => void;
  onClick?: (device: EvohomeDevice) => void;
  onUpdated?: (device: EvohomeDevice) => void;
  onStartEditName?: () => void;
  onSaveEditName?: (newName: string) => void;
  onCancelEditName?: () => void;
}

const EvohomeDeviceCardSettings: React.FC<EvohomeDeviceCardSettingsProps> = ({
  device,
  isSelected,
  editMode,
  isRoomEditing = false,
  isEditingName = false,
  dragHandleProps,
  onSelect,
  onClick,
  onUpdated,
  onStartEditName,
  onSaveEditName,
  onCancelEditName,
}) => (
  <Box sx={{
    position: 'relative',
    border: isSelected ? '1px solid #2391FF' : 'none',
    borderRadius: 2,
    overflow: 'visible',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  }}>
    <EvohomeDeviceCard
      device={device}
      onOpenModal={editMode || isRoomEditing || isEditingName ? undefined : onClick}
      onUpdated={onUpdated}
      interactionLocked={isRoomEditing || isEditingName}
      editMode={editMode}
      isRoomEditing={isRoomEditing}
      isEditingName={isEditingName}
      dragHandleProps={dragHandleProps}
      onStartEditName={onStartEditName}
      onSaveEditName={onSaveEditName}
      onCancelEditName={onCancelEditName}
      showBrandChip={editMode}
    />

    {editMode && onSelect && !isRoomEditing && (
      <Checkbox
        checked={isSelected}
        onChange={(e) => {
          e.stopPropagation();
          onSelect(device.id);
        }}
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: 'absolute',
          bottom: '-5px',
          right: '-5px',
          color: 'red',
          zIndex: 6,
          '& .MuiSvgIcon-root': { color: 'red' },
        }}
      />
    )}
  </Box>
);

export default EvohomeDeviceCardSettings;
